import { InjectionToken } from '@angular/core';

export const SECURITY_PUBLIC_ROUTES = new InjectionToken<PublicRoutes>(
  'SECURITY_PUBLIC_ROUTES',
);

export interface PublicRoutes {
  routes: string[];
}
